"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HEYGEN_SUBTITLE_MAX_BYTES = exports.HEYGEN_APP_URL = exports.HEYGEN_API_KEYS_URL = exports.HEYGEN_IMPORT_MAX_BYTES = exports.HEYGEN_MAX_BATCH_SIZE = void 0;
/** Max videos per "Import from HeyGen" batch (PRD story 2.2). */
exports.HEYGEN_MAX_BATCH_SIZE = 10;
/** Imported MP4s are buffered in memory by the media pipeline, same cap as Canva video. */
exports.HEYGEN_IMPORT_MAX_BYTES = 100 * 1024 * 1024;
exports.HEYGEN_API_KEYS_URL = "https://platform.heygen.com/api-keys";
exports.HEYGEN_APP_URL = "https://app.heygen.com/home";
/** Subtitle sidecars are small text files; anything bigger is not a caption track. */
exports.HEYGEN_SUBTITLE_MAX_BYTES = 2 * 1024 * 1024;
